/* istanbul ignore file */
export var EXTRA_SMALL = "2px";
export var SMALL = "4px";
export var DEFAULT = "8px";
//# sourceMappingURL=border-radius.js.map